import React, { useState } from "react";
import Auth from "..";
import { useTranslation } from "react-i18next";
import Button from "../../common/FormFields/Button";
import Password from "../../common/FormFields/Password";
import { withRouter } from "react-router-dom/cjs/react-router-dom";

const ValidatePassword = (props) => {
  const {
    reAuthenticateUser,
  } = props;
  const [password, setPassword] = useState("");
  const { t } = useTranslation();


  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    reAuthenticateUser({password})
  };

  return (
    <Auth>
      <div className="page-content">
        <main className="main auth">
          <div className="auth-content">
            <div className="modal">
              <form action="/" className="form auth-form">
                <h1 className="auth-title-2">{t("auth.enterPassword")}</h1>
                <div className="auth-body">
                  <div className="form-group">
                    <Password
                      placeholder={t("auth.enterPassword")}
                      label={t("auth.password")}
                      onChangeValue={setPassword}
                    />
                  </div>
                </div>
                <div className="auth-footer">
                  <Button
                    btnClassName="btn-primary"
                    id="sign-in-button-change-pass"
                    text={t("auth.confirm")}
                    onClick={handlePasswordSubmit}
                    disabled={false}
                    icon={false}
                  />
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </Auth>
  );
};

export default withRouter(ValidatePassword);
